<mat-toolbar class="subtitulo">Movimentações</mat-toolbar>
<div class="painel-principal" style="padding: 10px;">
    <div class="painel-consultar">
        <form #formulario="ngForm">
            <div fxLayout="row" >
                <fieldset sy fxFlex="50%" fxLayoutGap="20px" fxFlexOffset="20px">
                    <legend>Documento</legend>
                    <div fxLayout="row" style="height: 67%;">
                        <div ngModelGroup="comboEmpresa" fxFlex="100%" fxLayoutGap="20px" fxFlexOffset="20px">
                            <combo-pesquisavel #comboEmpresa 
                                            nome="empresa" 
                                            [itens]="empresas" 
                                            itemDescricao="nomeRazaoSocial"
                                            itemId="id"
                                            label="Empresa"
                                            [showDisplayId]="false" 
                                            [obrigatorio]="false"
                                            placeholder="Informe a empresa..."
                                            [(valor)]="filtro.empresa">
                            </combo-pesquisavel>
                        </div>
                    </div>
                    <div fxLayout="row" style="height: 67%;">
                        <mat-form-field fxFlex="25%" fxFlexOffset="20px">
                            <input matInput name= "dataInicio"
                                   [matDatepicker]="dataInicio" 
                                   placeholder="Data início" 
                                   [(ngModel)]="filtro.dataInicioDoc"
                                   (input)="onMascaraDataInput($event)">
                            <mat-datepicker-toggle matSuffix [for]="dataInicio"></mat-datepicker-toggle>
                            <mat-datepicker #dataInicio></mat-datepicker>
                        </mat-form-field>
                    
                        <mat-form-field fxFlex="25%" fxFlexOffset="20px">
                            <input matInput name= "dataFim"
                                   [matDatepicker]="dataFim" 
                                   [min]="filtro.dataInicioDoc"
                                   placeholder="Data fim" 
                                   [(ngModel)]="filtro.dataFimDoc"
                                   (input)="onMascaraDataInput($event)">
                            <mat-datepicker-toggle matSuffix [for]="dataFim"></mat-datepicker-toggle>
                            <mat-datepicker #dataFim></mat-datepicker>
                            <mat-error>Não pode ser inferior a data de início</mat-error>
                        </mat-form-field>

                        <mat-form-field fxFlex= "25%" fxFlexOffset="20px">
                            <input [(ngModel)]="filtro.numeroDocumento"
                                   name="numeroDocumento"
                                   placeholder="Número"
                                   matInput maxlength="20"
                                   />
                        </mat-form-field>
                        <mat-form-field fxFlex="25%" fxLayoutGap="20px" fxFlexOffset="20px" style="margin-bottom: 11px;">
                            <input [(ngModel)]="filtro.valor"
                                   currencyMask 
                                   name="valorMovimentacao" 
                                   placeholder="Valor"
                                   #valorMovimentacao
                                   matInput maxlength="13"
                                   [options]="{ prefix: '', thousands: '.', decimal: ',' }" />
                            <span matPrefix>R$&nbsp;</span>
                        </mat-form-field>        
                    </div>  
                </fieldset> 
                <fieldset sy fxFlex="40%" fxLayoutGap="20px" fxFlexOffset="20px">
                    <legend>Pagamento</legend>
                    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="16px" style="height: 67%;">
                        <mat-form-field fxFlex= "50%" >
                            <input matInput name= "dataInicioPag"
                                   [matDatepicker]="dataInicioPag" 
                                   placeholder="Data início" 
                                   [(ngModel)]="filtro.dataInicioPag"
                                   (input)="onMascaraDataInput($event)">
                            <mat-datepicker-toggle matSuffix [for]="dataInicioPag"></mat-datepicker-toggle>
                            <mat-datepicker #dataInicioPag></mat-datepicker>
                        </mat-form-field>
                    
                        <mat-form-field fxFlex= "50%" >
                            <input matInput name= "dataFimPag"
                                   [matDatepicker]="dataFimPag" 
                                   [min]="filtro.dataFimPag"
                                   placeholder="Data fim" 
                                   [(ngModel)]="filtro.dataFimPag"
                                   (input)="onMascaraDataInput($event)">
                            <mat-datepicker-toggle matSuffix [for]="dataFimPag"></mat-datepicker-toggle>
                            <mat-datepicker #dataFimPag></mat-datepicker>
                            <mat-error>Não pode ser inferior a data de início</mat-error>
                        </mat-form-field>
                    </div>  
                </fieldset> 
            </div>
            <div fxLayout="row" style="margin-top: 10px;">
                <fieldset sy fxFlex="100%" fxLayoutGap="20px" fxFlexOffset="20px">
                    <legend>Movimentação Contábil</legend>
                    <div fxLayout="row" fxLayoutGap="16px" style="height: 60%;">
                        <div ngModelGroup="comboProjeto" fxFlex="100%" fxLayoutGap="20px" fxFlexOffset="20px">
                            <combo-projeto [showDisplayId]="false" 
                                           [obrigatorio]="false" 
                                           [selecionado]="filtro.projeto"
                                           (valorChange)="onValorChangeProjeto($event)">
                            </combo-projeto>
                        </div>
                        <div ngModelGroup="comboContaDebito" fxFlex="100%" fxLayoutGap="20px" fxFlexOffset="20px" class="marginCombo">
                            <combo-pesquisavel #campoDebito 
                                               nome="contaDebito" 
                                               [itens]="planosContas" 
                                               itemDescricao="planoConta"
                                               itemId="id"
                                               label="Conta Contábil Débito"
                                               placeholder="Escolha..."
                                               [(valor)]="filtro.contaDebito"
                                               (valorChange)="carregarContaDebito($event)"
                                               style="margin-top: 10px;">
                            </combo-pesquisavel>
                        </div>
                        <div ngModelGroup="comboContaCredito" fxFlex="100%" fxLayoutGap="20px" fxFlexOffset="20px" class="marginCombo">
                            <combo-pesquisavel #campoCredito
                                               nome="contaCredito" 
                                               [itens]="planosContas" 
                                               itemDescricao="planoConta"
                                               itemId="id"
                                               label="Conta Contábil Crédito"
                                               placeholder="Escolha..."
                                               [(valor)]="filtro.contaCredito"
                                               (valorChange)="carregarContaCredito($event)"
                                               style="margin-top: 10px;">
                            </combo-pesquisavel>
                        </div>
                        <div ngModelGroup="comboContaAdicional" fxFlex="100%" fxLayoutGap="20px" fxFlexOffset="20px" class="marginCombo">
                            <combo-pesquisavel #campoAdicional 
                                               nome="contaAdicional" 
                                               [itens]="planosContas" 
                                               itemDescricao="planoConta"
                                               itemId="id"
                                               label="Conta Contábil Adicional"
                                               placeholder="Escolha..."
                                               [(valor)]="filtro.contaAdicional"
                                               (valorChange)="carregarContaAdicional($event)"
                                               style="margin-top: 10px;">
                            </combo-pesquisavel>
                        </div>
                        <mat-form-field fxFlex="25%" fxLayoutGap="20px" fxFlexOffset="20px">
                            <input [(ngModel)]="filtro.valorCategoria"
                                   currencyMask 
                                   name="valorCategoria" 
                                   placeholder="Valor"
                                   #valorCategoria
                                   matInput maxlength="13"
                                   [options]="{ prefix: '', thousands: '.', decimal: ',' }" />
                            <span matPrefix>R$&nbsp;</span>
                        </mat-form-field>       
                    </div> 
                </fieldset>
            </div>

            <div dir="rtl" class="botoes" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 20px;" fxFlexFill>
                <button mat-raised-button fxFlex="20%" (click)="consultar()" [disabled]="formulario.invalid">
                    CONSULTAR
                </button>

                <button mat-raised-button fxFlex="20%" style="padding-right: 20px" (click)="limpar()" route>
                    LIMPAR
                </button>
            </div>
            <div dir="rtl" class="botoes" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 20px;"
                fxFlexFill>
                <div>
                    <button matTooltip="Adicionar nova movimentação" mat-fab color="primary" [routerLink]="['/movimentacoes/cadastrar']"
                        routerLinkActive="router-link-active">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>
        </form>

        <div [hidden]="!mostrarTabela" style="margin-top: 20px;">
            <mat-paginator [length]="numberItens" [pageSizeOptions]="[10, 20, 40, 60, 80, 100]" showFirstLastButtons
                (page)="onEventPaginate($event)"></mat-paginator>
        </div>
        <table *ngIf="mostrarTabela; else tabelaSemDados" mat-table 
               matSort matSortDisableClear multiTemplateDataRows 
               [dataSource]="dataSource">

            <ng-container matColumnDef="programaprojeto">
                <th mat-header-cell *matHeaderCellDef style="width: 20%"> Projeto </th>
                <td mat-cell *matCellDef="let element"> 
                    <projeto-programa-cell [rateios]="element.categoriasMovimentos"></projeto-programa-cell>
                </td>
            </ng-container>
            
            <ng-container matColumnDef="fornecedorcredor">
                <th mat-header-cell *matHeaderCellDef style="width: 15%">Fornecedor/Credor</th>
                <td mat-cell *matCellDef="let element"> 
                    {{getFornecedorCredor(element)}}                    
                </td>
            </ng-container>

            <ng-container matColumnDef="cnpjcpf">
                <th mat-header-cell *matHeaderCellDef style="width: 8%"> CNPJ/CPF </th>
                <td mat-cell *matCellDef="let element"> 
                    {{getCnpfCpf(element)}}                    
                </td>
            </ng-container>      
            
            <ng-container matColumnDef="recibo">
                <th mat-header-cell *matHeaderCellDef style="width: 8%"> N.F / Recibo </th>
                <td mat-cell *matCellDef="let element"> 
                    {{element.nrDocumento}}                    
                </td>
            </ng-container>             

            <ng-container matColumnDef="dataDocumento">
                <th mat-header-cell *matHeaderCellDef style="width: 8%"> Data Documento </th>
                <td mat-cell *matCellDef="let element"> {{ element.dataDocumento | dataSimples }} </td>
            </ng-container>
           
            <ng-container matColumnDef="valor">
                <th mat-header-cell *matHeaderCellDef> Valor </th>
                <td mat-cell *matCellDef="let element"> {{ element.valorMovimentacao | currency: 'BRL' }} </td>
            </ng-container>

            <ng-container matColumnDef="nrtransacao">
                <th mat-header-cell *matHeaderCellDef style="width: 8%"> Nº Transação</th>
                <td mat-cell *matCellDef="let element" style="text-align: center;"> 
                    {{ getUltimoPagamento(element)?.numeroDocPagamento }}
                </td>
            </ng-container>
          
            <ng-container matColumnDef="dataUltimoPagamento">
                <th mat-header-cell *matHeaderCellDef style="width: 8%">Último Pag.</th>
                <td mat-cell *matCellDef="let element"> 
                    {{getUltimoPagamento(element)?.dataPagamento | dataSimples  }}
                </td>
            </ng-container>

            <ng-container matColumnDef="categorias">
                <th mat-header-cell *matHeaderCellDef style="width: 12%"> Contas Contábeis </th>
                <td mat-cell *matCellDef="let element"> 
                    <categorias-cell [movimento]="element"></categorias-cell>
                </td>
            </ng-container>

            <ng-container matColumnDef="dataproximasfaturas">
                <th mat-header-cell *matHeaderCellDef> Próximas faturas </th>
                <td mat-cell *matCellDef="let element"> 
                    <proximas-fatura-cell [movimento]="element"></proximas-fatura-cell>
                </td>
            </ng-container>            

            <ng-container matColumnDef="acoes" stickyEnd>
                <th mat-header-cell *matHeaderCellDef style="width: 5%"> Ações </th>
                <td mat-cell *matCellDef="let element">
                    <button *ngIf="perfilAcesso.deleta"  mat-button (click)="deletar(element)" style="min-width: auto; padding: 0px">
                        <mat-icon>delete</mat-icon>
                    </button>
                    <button *ngIf="perfilAcesso.consulta" mat-button (click)="atualizar(element)" style="min-width: auto; padding: 0px">
                        <mat-icon>search</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let element; columns: displayedColumns;"></tr>
        </table>
        <div [hidden]="!mostrarTabela">
            <mat-paginator [length]="numberItens" [pageSizeOptions]="[10, 20, 40, 60, 80, 100]" showFirstLastButtons
                (page)="onEventPaginate($event)"></mat-paginator>
        </div>
        
        <ng-template #tabelaSemDados >
            <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 20px">
                {{msg}}
            </div>
        </ng-template>
    </div>
</div>